import type { TargetingBaseType } from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseType';
import type { TagItem } from '@/components/common/FormExpandableSection/FormExpandableSection';

export function getTemperatureAndWeatherTags(
  temperatureAndWeather: TargetingBaseType['temperatureAndWeather']
): TagItem[] {
  const result: TagItem[] = [];
  if (temperatureAndWeather?.temperature?.min || temperatureAndWeather?.temperature?.max) {
    const min = temperatureAndWeather.temperature.min || '?';
    const max = temperatureAndWeather.temperature.max || '?';
    result.push({ label: `${min}° – ${max}°` });
  }
  const weatherConditions = temperatureAndWeather?.weatherConditions as string[] | undefined;
  if (weatherConditions && weatherConditions.length > 0) {
    result.push({ label: `${weatherConditions.length} conditions` });
  }
  if (temperatureAndWeather?.uv?.min) {
    result.push({ label: `UV from ${temperatureAndWeather.uv.min}` });
  }

  return result;
}
